import {Injectable} from '@angular/core';
import {NavigationEnd} from '@angular/router';
import {APP_YANDEX_METRIC_ID} from '../constants/yandex-metric.constant';
import {Subject, takeUntil} from 'rxjs';
import {TuiDestroyService} from '@taiga-ui/cdk';

declare let ym: any;

@Injectable({
  providedIn: 'root',
})
export class YandexMetricService {
  reachGoal = new Subject<string>();

  constructor(private readonly destroy$: TuiDestroyService) {
    this.sbsReachGoal();
  }

  sendBrowsingData(event: NavigationEnd): void {
    ym(APP_YANDEX_METRIC_ID, 'hit', event.urlAfterRedirects);
  }

  sendUserData(user: {email: string; name: string}): void {
    ym(APP_YANDEX_METRIC_ID, 'userParams', {
      Name: user.name,
      Email: user.email,
    });
  }

  private sbsReachGoal(): void {
    this.reachGoal
      .pipe(takeUntil(this.destroy$))
      .subscribe(trackOn => this.onReachGoal(trackOn));
  }

  private onReachGoal(name: string): void {
    ym(APP_YANDEX_METRIC_ID, 'reachGoal', name);
  }
}
